import axios, { AxiosResponse } from "axios";
import axiosRetry from "axios-retry";
import { gaCategory, gaAction } from "types/HsbGaTypes";
import { getResponseMessage } from "core/interfaces/data/Base";
import { IGeoLocation, IGeoLocationRequest, IGeoLocationResponse } from "core/interfaces/data/IGeoLocationRequest";
import ReactGA from "react-ga4";

// questo serve per fare la richiesta una seconda volta se in caso la prima non va a buon fine
axiosRetry(axios, {
	retries: 2,
});

// serve per settare i cookie in risposta
axios.defaults.withCredentials = true;

class GeoLocationRepository {
	/**
	 * Metodo che ritorna i possibili comuni dato l'imput
	 * Le props, ovvero i parametri che servono per fare la richiesta li dichiaro
	 * con una interfaccia che contiene i campi che servono per chiamare il servizio
	 * Nella richiesta di Axios gli do il tipo così puoi usare l'intellisense
	 * Rispetto ai dati che hai messo nella Response crei l'interfaccia che mappa quei campi
	 */
	async getGeoLocationByDescription(props: IGeoLocationRequest): Promise<IGeoLocation[] | undefined> {
		const url = `${window.CONFIG.REACT_APP_WS_HSB}/GlobalLocationGetByDescription`;

		try {
			const res = await axios.post<IGeoLocationRequest, AxiosResponse<IGeoLocationResponse>>(url, props);

			if (res.data.Errors) {
				throw new Error(getResponseMessage(res.data.Errors));
			}

			let buildLocations:IGeoLocation[]=[]
			for(let l of JSON.parse(res.data.GlobalLocations) as IGeoLocation[]){
				let addr=l.Address
				let check=true
				for(let el of buildLocations){
					if(el.Address.PostCode===addr.PostCode){check=false;break}
					// else if(el.Address.State===addr.State){check=false;break}
					// else if(el.Address.County===addr.County){check=false;break}
					// else if(el.Address.HouseNumber===addr.HouseNumber){check=false;break}
					// else if(el.Address.Hamlet===addr.Hamlet){check=false;break}
				}
				if(check) buildLocations.push(l)
			}

			const locations: IGeoLocation[] = buildLocations
			ReactGA.event({ category: gaCategory.search, action: gaAction.addressSearch });
			return locations;
		} catch (err) {
			console.log(err);
		}
	}

	async getGeoLocationById(props: IGeoLocationRequest): Promise<IGeoLocation | undefined> {
		const url = `${window.CONFIG.REACT_APP_WS_HSB}/GlobalLocationGetById`;

		try {
			const res = await axios.post<IGeoLocationRequest, AxiosResponse<IGeoLocationResponse>>(url, props);

			if (res.data.Errors) {
				throw new Error(getResponseMessage(res.data.Errors));
			}

			const locations: IGeoLocation = JSON.parse(res.data.GlobalLocations);
			ReactGA.event({ category: gaCategory.search, action: gaAction.addressSearch });
			return locations;
		} catch (err) {
			console.log(err);
		}
	}
}
var GeoLocationRep=new GeoLocationRepository()
export default GeoLocationRep;
